import React from "react";
export default function TimeBlockCell({ block }) {
  return <div className="schedule-time-cell"><div>{block?.label}</div>{block?.time && <small>{block.time}</small>}</div>;
}
